/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, useRef } from 'react'
import { useDrag } from '@use-gesture/react'
import { useThree } from '@react-three/fiber'
import { useDispatch, useSelector } from 'react-redux'
import debounce from 'lodash.debounce';

import * as actionCreator from '../../../../../action/index';
import { params, const_var } from '../../../../../redux/reducers/reducer';
import Wall from './Wall';
import Legs from './Legs';
import OutLineSection from './OutLineSection';
import { controls } from '../../../../../redux/reducers/common/eventReducer';
import { makeTranslucent } from '../../../../../helpers/building/building_config/componentConfig';
import DoorWindows from '../../../DoorWindows';

const Storage = ({normalMap, envMap}) => {
    const get = useThree((state) => state.get)
    const dispatch = useDispatch();
    const prevStorageLengthRef = useRef();
    const prevLeanLengthRef = useRef();
    const distance = const_var.controls?.getDistance([0, 0, 0]);
    const leanToTrussPosInfo = useSelector(state => state.reducer.leanToTrussPosInfo)
    const isActiveWallSubTab = useSelector(state => state.reducer.isActiveWallSubTab)
    const isResetBuilding = useSelector(state => state.reducer.isResetBuilding)

    const [isDragable, setIsDragable] = useState(true);
    const [position, setPosition] = useState(0);
    const [startPosition, setStartPosition] = useState(0);
    const [dragging, setDragging] = useState(false);
    const [isHovered, setIsHovered] = useState(false)
    const [overlapTrussArr, setOverlapTrussArr] = useState(false);

    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    const prevStorageLengthValue = prevStorageLengthRef.current || parseInt(params.add_storage_front);
    const prevLeanLengthValue = prevLeanLengthRef.current || params.leanF_p_d;
    
    const camPosZ = const_var.camera?.position?.z;

    let offset = 1
    if(camPosZ >= 0) offset = 1;
    else if(camPosZ < 0) offset = -1;

    const railWidth = 0.2

    const limit = useMemo(() => {
        return {
            min: 0,
            max: params.leanF_p_d - parseInt(params.add_storage_front) - railWidth
        }
    }, [params.leanF_p_d, params.add_storage_front])
        
    const debounceForDragLean = debounce(() => {
        setTimeout(() => {
            setIsDragable(true)
            get().gl.domElement.style.cursor = 'auto'
            clearTimeout();
        }, [750])
    }, [750])

    const bind = useDrag(
        ({ down, delta, first, event, movement: [mx, my] }) => {
            
            if (controls.isCheckActiveTab === 'walls' && isActiveWallSubTab === 'front_lean_to' && const_var.isStorageMovementEnableForMfg) {
                event.stopPropagation();
                if (first) {
                    if (!params.is_translusant) makeTranslucent(null, null, params.is_translusant, const_var.scene, true, 'frontlean-storage');
                    setStartPosition(position);
                }

                if (down === true) {
                    dispatch(actionCreator.updateEditIconVisiblity())
                    const_var.controls.enableRotate = false;
                    if (isDragable) {
                        get().gl.domElement.style.cursor = 'move';
                        
                        const nextPosition = startPosition + (mx * offset) * (distance / 1000);
                        if (nextPosition < limit.min) {
                            setPosition(limit.min)
                        } else if (nextPosition > limit.max) {
                            setPosition(limit.max)
                        } else {
                            setPosition(nextPosition);
                        } 
                        setDragging(true)
                    }
                } else {
                    setIsDragable(false);
                    if (!params.is_translusant) makeTranslucent(null, null, params.is_translusant, const_var.scene, false, 'frontlean-storage');

                    const newPosition = leanToTrussPosInfo.frontLeanTo.reduce((prev, curr) => Math.abs(curr - position + params.leanF_p_d / 2 - params.leanF_p_pos - railWidth) < Math.abs(prev - position + params.leanF_p_d / 2 - params.leanF_p_pos - railWidth) ? curr : prev);
                    const_var.controls.enableRotate = true;
                    get().gl.domElement.style.cursor = 'auto'

                    let tempPosition = 0;
                    if(params.leanF_p_d - position - parseInt(params.add_storage_front) < legDistance / 2) {
                        tempPosition = params.leanF_p_d - parseInt(params.add_storage_front) - railWidth;
                    } else if (newPosition + params.leanF_p_d / 2 - params.leanF_p_pos - railWidth < legDistance / 2) {
                        tempPosition = 0;
                    } else {
                        tempPosition = parseFloat((Math.round(newPosition * 10) / 10 + params.leanF_p_d / 2 - params.leanF_p_pos - railWidth).toFixed(4));
                    }

                    let isFind = false;
                    const doorsArray = [...const_var.newDoorsArray]
                    const storageSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'F_L_F_S_W');
                    const leanSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'F_L_F_W');

                    if (storageSideDoorsArr.length > 0 && leanSideDoorsArr.length > 0) {
                        storageSideDoorsArr.forEach(item_st => {
                            const tempChangedDoorPosX = item_st.positionX + (tempPosition - startPosition);

                            leanSideDoorsArr.forEach(item_lean => {
                                if (Math.abs(item_lean.positionX - tempChangedDoorPosX) < item_lean.width / 2 + item_st.width / 2 + const_var.componentDistance &&
                                    Math.abs(item_lean.positionY - item_st.positionY) < item_lean.height / 2 + item_st.height / 2 + const_var.componentDistance)
                                {
                                    isFind = true;
                                }
                            })
                        })
                    }

                    if (isFind) {
                        dispatch(actionCreator.handleShowAlertBox("notAllowNewPosition"));
                        setPosition(startPosition)
                        setStartPosition(startPosition)
                    } else {
                        setPosition(tempPosition)
                        setStartPosition(tempPosition);
                        dispatch(actionCreator.onDragUtilityPriceReset("front"));
                        dispatch(actionCreator.updateFrontLeanStoragePosition(tempPosition, startPosition, true))

                        const updatedNewDoorArr = const_var.newDoorsArray.map((item) => {
                            if (item.userData.wallName === 'F_L_F_S_W') {
                                return {
                                    ...item,
                                    positionX: item.positionX + (tempPosition - startPosition),
                                    minLimitX: item.minLimitX + (tempPosition - startPosition),
                                    maxLimitX: item.maxLimitX + (tempPosition - startPosition)
                                }
                            }
                            return item;
                        })

                        if (JSON.stringify(const_var.newDoorsArray) !== JSON.stringify(updatedNewDoorArr)) {
                            dispatch(actionCreator.updateDoorWindowsArray(updatedNewDoorArr, true));
                        }
                        let newArray;
                        if(params.frontLeanStoragePosition === params.leanF_p_d - parseInt(params.add_storage_front) - railWidth){
                            if (const_var.newDoorsArray.find(item => item.userData.wallName === "F_L_R_W")) {
                                newArray = const_var.newDoorsArray.filter(item => item.userData.wallName !== "F_L_R_S_W")
                                dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                            } else if (const_var.newDoorsArray.find(item => item.userData.wallName === "F_L_R_S_W")){
                                const_var.newDoorsArray.filter(item => item.userData.wallName === "F_L_R_S_W").map(item => item.userData.wallName = "F_L_R_W");
                                dispatch(actionCreator.updateDoorWindowsArray(const_var.newDoorsArray, true));
                            }
                        } else if(params.frontLeanStoragePosition <= 0){
                            if (const_var.newDoorsArray.find(item => item.userData.wallName === "F_L_L_W")) {
                                newArray = const_var.newDoorsArray.filter(item => item.userData.wallName !== "F_L_L_S_W")
                                dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                            } else if (const_var.newDoorsArray.find(item => item.userData.wallName === "F_L_L_S_W")) {
                                const_var.newDoorsArray.filter(item => item.userData.wallName === "F_L_L_S_W").map(item => item.userData.wallName = "F_L_L_W");
                                dispatch(actionCreator.updateDoorWindowsArray(const_var.newDoorsArray, true));
                            }
                        }
                    }

                    setDragging(false);
                    debounceForDragLean()
                }
            }
        },
    );

    // useMemo(() => {
    //     if(leanToTrussPosInfo.frontLeanTo.length !== 0){
    //         const newPosition = leanToTrussPosInfo.frontLeanTo.reduce((prev, curr) => Math.abs(curr - position + params.leanF_p_d / 2 - params.leanF_p_pos - railWidth) < Math.abs(prev - position + params.leanF_p_d / 2 - params.leanF_p_pos - railWidth) ? curr : prev);
    //         if(params.leanF_p_d - position - parseInt(params.add_storage_front) < legDistance / 2){
    //             setPosition(params.leanF_p_d - parseInt(params.add_storage_front) - railWidth)
    //             setStartPosition(params.leanF_p_d - parseInt(params.add_storage_front) - railWidth);
    //             dispatch(actionCreator.updateFrontLeanStoragePosition(params.leanF_p_d - parseInt(params.add_storage_front) - railWidth, startPosition, true))
    //         } else{
    //             setPosition(newPosition + params.leanF_p_d / 2 - params.leanF_p_pos - railWidth)
    //             setStartPosition(newPosition + params.leanF_p_d / 2 - params.leanF_p_pos - railWidth);
    //             dispatch(actionCreator.updateFrontLeanStoragePosition(newPosition + params.leanF_p_d / 2 - params.leanF_p_pos - railWidth, startPosition, true))
    //         }
    //     }
    // }, [params.leanF_p_d, leanToTrussPosInfo.frontLeanTo]);

    useMemo(() => {
        // Store the previous storage size(add_storage_front) value
        prevStorageLengthRef.current = parseInt(params.add_storage_front);
        prevLeanLengthRef.current = params.leanF_p_d;
    
        if (prevStorageLengthValue >= params.leanF_p_d) {
            // Remove End Storage if the building length is smaller than storage size.
            dispatch(actionCreator.toggleAddUtilityCheckboxChangeForFront(true))
        } else {
            if (!dragging) {
                if (params.leanF_p_d - position - parseInt(params.add_storage_front) - railWidth <= 0) {
                    const newPosition = params.leanF_p_d - parseInt(params.add_storage_front) - railWidth;
                    setPosition(newPosition);
                    setStartPosition(newPosition)
                    dispatch(actionCreator.updateFrontLeanStoragePosition(newPosition));

                    if (prevLeanLengthValue - position - parseInt(params.add_storage_front) - railWidth <= 0) {
                        const_var.newDoorsArray.filter((e) => e.userData.wallName === 'F_L_F_S_W').forEach((item) => {
                            const newPositionX = item.positionX - (prevLeanLengthValue - params.leanF_p_d - railWidth) / 2;
                            dispatch(actionCreator.updateDoorWindowPosition(item.uniqueId, newPositionX))
                        });
                    } else {
                        const_var.newDoorsArray.filter((e) => e.userData.wallName === 'F_L_F_S_W').forEach((item) => {
                            const newPositionX = item.positionX + ((prevLeanLengthValue - position - railWidth) - (prevLeanLengthValue - params.leanF_p_d)) / 2;
                            dispatch(actionCreator.updateDoorWindowPosition(item.uniqueId, newPositionX))
                        });
                    }
                } else {
                    const_var.newDoorsArray.filter((e) => e.userData.wallName === 'F_L_F_S_W').forEach((item) => {
                        const newPositionX = item.positionX + (prevLeanLengthValue - params.leanF_p_d) / 2;
                        dispatch(actionCreator.updateDoorWindowPosition(item.uniqueId, newPositionX))
                    });
                }

                const doorsArray = [...const_var.newDoorsArray]
                const storageSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'F_L_F_S_W');
                const leanSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'F_L_F_W');

                if (storageSideDoorsArr.length > 0 && leanSideDoorsArr.length > 0) {
                    storageSideDoorsArr.forEach(item_st => {
                        leanSideDoorsArr.forEach(item_lean => {
                            if (Math.abs(item_lean.positionX - item_st.positionX) < item_lean.width / 2 + item_st.width / 2 + const_var.componentDistance &&
                                Math.abs(item_lean.positionY - item_st.positionY) < item_lean.height / 2 + item_st.height / 2 + const_var.componentDistance)
                            {
                                dispatch(actionCreator.updateDoorWindowsArray(const_var.newDoorsArray.filter(item => item.uniqueId !== item_lean.uniqueId), true));
                            }
                        })
                    })
                }
                
                let newArray;
                if(params.frontLeanStoragePosition === params.leanF_p_d - parseInt(params.add_storage_front) - railWidth){
                    if (const_var.newDoorsArray.find(item => item.userData.wallName === "F_L_R_W")) {
                        newArray = const_var.newDoorsArray.filter(item => item.userData.wallName !== "F_L_R_S_W")
                        dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                    } else if (const_var.newDoorsArray.find(item => item.userData.wallName === "F_L_R_S_W")){
                        const_var.newDoorsArray.filter(item => item.userData.wallName === "F_L_R_S_W").map(item => item.userData.wallName = "F_L_R_W");
                        dispatch(actionCreator.updateDoorWindowsArray(const_var.newDoorsArray, true));
                    }
                } else if(params.frontLeanStoragePosition <= 0){
                    if (const_var.newDoorsArray.find(item => item.userData.wallName === "F_L_L_W")) {
                        newArray = const_var.newDoorsArray.filter(item => item.userData.wallName !== "F_L_L_S_W")
                        dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                    } else if (const_var.newDoorsArray.find(item => item.userData.wallName === "F_L_L_S_W")) {
                        const_var.newDoorsArray.filter(item => item.userData.wallName === "F_L_L_S_W").map(item => item.userData.wallName = "F_L_L_W");
                        dispatch(actionCreator.updateDoorWindowsArray(const_var.newDoorsArray, true));
                    }
                }
            }
        }
    
    }, [params.leanF_p_d, params.add_storage_front]);

    useMemo(() => {
        if(!params.apiCallAfterEdit && !const_var.isFromPickThis){
            setPosition(0);
            setStartPosition(0)
            dispatch(actionCreator.updateFrontLeanStoragePosition(0));
        } else {
            setPosition(params.frontLeanStoragePosition );
            setStartPosition(params.frontLeanStoragePosition )
            dispatch(actionCreator.updateFrontLeanStoragePosition(params.frontLeanStoragePosition ));
        }
    }, [params.building_type_name, isResetBuilding])
    
    return (        
        <group 
            position={[position, 0, 0]}
            {...bind()}
            onPointerOver={(e) => {
                if(controls.isCheckActiveTab !== 'doorwindow'){
                    e.stopPropagation(); 
                    setIsHovered(true);
                }
            }}
            onPointerOut={() => setIsHovered(false)}
            name='frontlean-storage'
        >
            <Wall />
            <Legs overlapTrussArr={overlapTrussArr} normalMap={normalMap} envMap={envMap} />
            
            <group position={dragging ? undefined : [-position - params.leanF_p_pos, 0, 0]}>
                <DoorWindows overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} section={'frontlean-storage'} />
            </group>

            {(isHovered || dragging) && const_var.isStorageMovementEnableForMfg && controls.isCheckActiveTab === 'walls' && isActiveWallSubTab === 'front_lean_to' && <OutLineSection />}
        </group>
    )
}

export default Storage